import { render, staticRenderFns } from "./EmailDPQuotation.vue?vue&type=template&id=2a9f85bf"
import script from "./EmailDPQuotation.vue?vue&type=script&lang=js"
export * from "./EmailDPQuotation.vue?vue&type=script&lang=js"
import style0 from "./EmailDPQuotation.vue?vue&type=style&index=0&id=2a9f85bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports